import { getSierraVariables } from './getSierraVariables.ts';

import { type SupportChatTouchpoint, type PreChatFields } from '../../types.ts';

function updateSierraVariables(variables: {
    touchpoint: SupportChatTouchpoint;
    preChatFields: PreChatFields;
}): void {
    window.sierra?.updateVariables?.(getSierraVariables(variables));
}

export { updateSierraVariables };
